<!-- Pipeline Mini -->
<div class="pipeline-mini">
  <span
    class="pipeline-dot"
    [class.completed]="currentIndex > 1"
    [class.active]="currentIndex == 1"
  ></span>
  <span
    class="pipeline-label"
    [class.completed]="currentIndex > 1"
    [class.active]="currentIndex == 1"
    >Manifest</span
  >
  <span class="pipeline-arrow">→</span>
  <span
    class="pipeline-dot"
    [class.completed]="currentIndex > 2"
    [class.active]="currentIndex == 2"
  ></span>
  <span
    class="pipeline-label"
    [class.completed]="currentIndex > 2"
    [class.active]="currentIndex == 2"
    >Script</span
  >
  <span class="pipeline-arrow">→</span>
  <span
    class="pipeline-dot"
    [class.completed]="currentIndex > 3"
    [class.active]="currentIndex == 3"
  ></span>
  <span
    class="pipeline-label"
    [class.completed]="currentIndex > 3"
    [class.active]="currentIndex == 3"
    >Moodboard</span
  >
  <span class="pipeline-arrow">→</span>
  <span
    class="pipeline-dot"
    [class.completed]="currentIndex > 4"
    [class.active]="currentIndex == 4"
  ></span>
  <span
    class="pipeline-label"
    [class.completed]="currentIndex > 4"
    [class.active]="currentIndex == 4"
    >Storyboard</span
  >
  <span class="pipeline-arrow">→</span>
  <span
    class="pipeline-dot"
    [class.completed]="currentIndex > 5"
    [class.active]="currentIndex == 5"
  ></span>
  <span
    class="pipeline-label"
    [class.completed]="currentIndex > 5"
    [class.active]="currentIndex == 5"
    >Video</span
  >
  <span class="pipeline-arrow">→</span>
  <span
    class="pipeline-dot"
    [class.completed]="currentIndex > 6"
    [class.active]="currentIndex == 6"
  ></span>
  <span
    class="pipeline-label"
    [class.completed]="currentIndex > 6"
    [class.active]="currentIndex == 6"
    >Sound</span
  >
</div>
